import { findIn } from '../../app/helpers/entity'
import { SET_PRICING_PAYMENT_METHOD_TYPES, SET_PRICING_PAYMENT_METHOD_TYPES_LABELS } from '../../app/core/constants'
import { isTvDip } from '../../app/helpers/fn'
import { checkCSIntersection, newItemPriceError, openCSModal } from './addChannelSet.controller'

/**
 * AddLiveEventSetCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

AddLiveEventSetCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddLiveEventSetCtrl controller
 *
 * @class AddLiveEventSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddLiveEventSetCtrl
 */
/* @ngInject */
export default function AddLiveEventSetCtrl ($scope, $http, $location, $uibModal, LiveEventSet, NetworkCurrency, alertLiteSvc, cs, pckg) {
  var vm = this
  vm.ready = false

  vm.set_pricing_payment_method_types = SET_PRICING_PAYMENT_METHOD_TYPES
  vm.set_pricing_payment_method_types_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS
  vm.types = ['PER_ITEM']

  /**
   * Live Event Set
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {models.LiveEventSet}
   */
  vm.les = cs

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  const networkId = vm.pckg.id

  vm.notTvDip = !isTvDip()

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:PaymentSystemCtrl
   * @name vm.currencies
   * @type {models.NetworkCurrency[]}
   */

  // load currencies
  NetworkCurrency.loadAll({ network: pckg })
    .then(data => data.filter(c => c.enabled))
    .to(vm.currencies = [])
    .then(() => {
      vm.les.pricing.currency = vm.les.pricing.currency
        ? findIn(vm.currencies)(vm.les.pricing.currency)
        : vm.currencies[0]
    })
    .finally(() => { vm.extraLoaded = true })

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {Boolean}
   */
  vm.isNew = cs._isNew()

  /**
   * Filter value for live event sets
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {string}
   */
  vm.filter = ''

  /**
   * Filter value for assigned live events sets
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {string}
   */
  vm.assignedLiveEventsFilter = ''

  /**
   * Filter assigned live event sets
   *
   * @param {LiveEvent} le
   * @memberof mwApp/packages.controller:AddLiveEventSetSetCtrl
   */
  vm.filteredAssignedLiveEvents = function (le) {
    return vm.filterAssigned && vm.filterAssigned.length > 0
      ? le.name.toLowerCase().includes(vm.filterAssigned.toLowerCase())
      : true
  }

  /**
   * Items arrays
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {Object}
   */
  vm.items = {
    available: {
      name: 'available',
      events: []
    },
    assigned: {
      name: 'assigned',
      events: []
    }
  }

  vm.liveEventIdsToRemove = []

  /**
   * Table state
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {Object[]}
   */
  vm.liveEventDefaultPagination = {
    'live-event-name': '',
    page: 0,
    last: false,
    count: 25
  }

  vm.searchContentAssignedParams = angular.copy(vm.liveEventDefaultPagination)

  /**
   * Get assigned Live Events
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {Object[]}
   */
  vm.getAssignedLiveEvents = function (isFromFirstPage) {
    if (!vm.les.id) {
      vm.filterAssigned = vm.searchContentAssignedParams['live-event-name']
      return
    }
    if (isFromFirstPage) {
      vm.searchContentAssignedParams.page = 0
      vm.liveEventIdsToRemove = []
    } else {
      vm.searchContentAssignedParams.page++
    }

    vm.les._getAssignedLiveEvents(networkId, { ...vm.searchContentAssignedParams })
      .then((result) => {
        if (isFromFirstPage) {
          vm.items.assigned.events = []
        }
        const content = angular.copy(result.content)
        vm.items.assigned.events.push(...content)
        vm.liveEventIdsToRemove.push(...content.map(i => i.id))
        vm.searchContentAssignedParams.last = result.last
        vm.searchContentAssignedParams.page = result.number
      })
  }

  if (!vm.isNew) { // TODO: refactoring
    vm.getAssignedLiveEvents(true)
  }

  /**
   * get available Live Events
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   * @type {Object[]}
   */

  vm.searchContentAvailableParams = angular.copy(vm.liveEventDefaultPagination)

  vm.les._getAvailableLiveEvents(networkId, vm.liveEventDefaultPagination)
    .then((result) => {
      vm.items.available.events = result.content
      vm.searchContentAvailableParams.last = result.last
    })

  vm.getAvailableEvents = function () {
    vm.les._getAvailableLiveEvents(vm.pckg.id, { 'live-event-name': vm.filter || '', page: 0 }).then((result) => {
      vm.items.available.events = result.content.filter(c => !vm.items.assigned.events.find(evt => evt.id === c.id))
      vm.searchContentAvailableParams.last = result.last
      vm.searchContentAvailableParams.page = 0
    })
  }

  vm.saveSet = function () {
    vm.setDisable()
    cs._save((data) => {
      data.liveEventIdsToAssign = []
      vm.items.assigned.events.forEach(event => {
        data.liveEventIdsToAssign.push(event.id)
      })
      if (!vm.isNew) {
        data.liveEventIdsToRemove = vm.liveEventIdsToRemove.filter(item => !data.liveEventIdsToAssign.includes(item))
      }
    })
      .then((res) => {
        cs._update().then(() => {
          if (vm.isNew) {
            $location.url(cs._publicListUrl + res.data.payload.id)
          }
        })
      })
      .then(vm.location(cs).reload)
      .finally(vm.unsetDisable)
  }

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   */
  vm.submit = function () {
    if (vm.items.assigned.events.length === 0) {
      return
    }
    vm.checkIntersection()
      .then(
        () => {
          newItemPriceError($uibModal, cs, cs.assignedSubscriptions, vm.items.assigned.events, vm.liveEventIdsToRemove)
            .then(() => { vm.saveSet() })
        })
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const { last, count } = vm.searchContentAvailableParams
    const scroll = event.wheelDelta < 0 && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6
    if (!last && (scroll || vm.items.available.events.length < 0.7 * count)) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        vm.searchContentAvailableParams.page++
        vm.les._getAvailableLiveEvents(vm.pckg.id, { ...vm.searchContentAvailableParams, 'live-event-name': vm.filter })
          .then((result) => {
            vm.items.available.events = vm.items.available.events.concat(result.content)
            vm.searchContentAvailableParams.last = result.last
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of Assigned select list
   *
   * @param event
   */
  vm.$timerContentAssignedScroll = 0
  vm.contentCallbackAssignedScroll = (event) => {
    const { last, count } = vm.searchContentAssignedParams
    const scroll = event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6
    if (!vm.isNew && !last && (scroll || vm.items.assigned.events.length < 0.7 * count)) {
      window.clearTimeout(vm.$timerContentAssignedScroll)
      vm.$timerContentAssignedScroll = window.setTimeout(vm.getAssignedLiveEvents, 700)
    }
  }

  // see http://marceljuenemann.github.io/angular-drag-and-drop-lists/demo/#/multi

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    $scope.form.$setDirty()
    if (list.name === 'assigned' && vm.items.available.events < vm.searchContentAvailableParams.count * 0.7) {
      vm.contentCallbackAvailableScroll(event)
    }
    if (list.name === 'available' && vm.items.assigned.events < vm.searchContentAssignedParams.count * 0.7) {
      vm.contentCallbackAssignedScroll(event)
    }

    // eslint-disable-next-line no-undef
    event.stopPropagation()
    list.events = list.events
      .slice(0, index)
      .concat(items)
      .concat(list.events.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete Live event from Live Events Set
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   */
  vm.deleteLiveEventFromSet = function (le) {
    vm.contentCallbackAssignedScroll(event)
    event.preventDefault()
    le.selected = false
    vm.items.assigned.events = vm.items.assigned.events.filter(e => e.id !== le.id)
    vm.items.available.events.push(le)
    $scope.form.$setDirty()
    vm.checkIntersection(true)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
    vm.checkIntersection()
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.events = list.events.filter(item => !item.selected)
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddLiveEventSetCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicUrl + '/contentSets#live_event_sets')
    }
  }

  vm.openConflicts = function (item) {
    event.stopPropagation()
    item.openConflict = true
    openCSModal($uibModal, vm.les, item, vm.checkIntersection)
  }

  vm.checkIntersection = function (checkOnDelete = false) {
    if (checkOnDelete && !vm.hasCSintersection) { return }

    vm.setDisable()
    return checkCSIntersection($http, alertLiteSvc, vm.les, vm.items.assigned.events, vm.isNew)
      .then(data => { vm.hasCSintersection = data })
      .finally(vm.unsetDisable)
  }
}
